import {
  Box,
  Button,
  Checkbox,
  Divider,
  Fab,
  FormControlLabel,
  Menu,
  MenuItem,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import FlatSheet from "./Items/FlatSheet";
import Coil from "./Items/Coil";
import Panel from "./Items/Panel";
import TrimAndFlashing from "./Items/TrimAndFlashing";
import BenchWork from "./Items/BenchWork";
import CopingCap from "./Items/CopingCap";
import CopingCapCleat from "./Items/CopingCapCleat";
import SplicePlate from "./Items/SplicePlate";
import Accessory from "./Items/Accessory";
import OrderTitle from "../../../../../components/OrderTitle";
import estimatePdfDownloadHandler from "../../../../../helper/estimatePdfDownloader";
import { AuthContext } from "../../../../../context/AuthContext";
import {
  Add,
  AttachMoney,
  Cancel,
  Check,
  Close,
  Download,
  Edit,
  KeyboardArrowUp,
  LocalShipping,
  Send,
  Undo,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { SnackAlertContext } from "../../../../../context/SnackAlertContext";
import SelectSalesRep from "../../QuoteForm/SelectSalesRep";
import AdminApproveDialog from "./AdminApproveDialog";
import WorkOrderButton from "../../../../../components/PdfButtons/WorkOrderButton";
import { currencyFormatNoDecimals } from "../../../../../components/NewDetail/calculations/utils";
import SendQuoteDialog from "./SendQuoteDialog";
import Comments from "./Comments";
import AdminCancelOrderDialog from "./AdminCancelOrderDialog";
import MaterialSummary from "./MaterialSummary";
import PurchaseOrders from "../../../PurchaseOrders/PurchaseOrders";
import LaborSummary from "./LaborSummary";
import PrintableQRCode from "../../../../../components/QrCode/PrintableQRCode";
import JobSchedule from "./JobSchedule";
import JobDetails from "./JobDetails";
import AdminRequoteOrderDialog from "./AdminRequoteOrderDialog";
import ShopCompletionStatusDialog from "./ShopCompletionStatusDialog";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import RFPDialog from "./RFPDialog";
import AdminCloseOrderDialog from "./AdminCloseOrderDialog";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const QuotePreview = ({ quote, onQuoteUpdated }) => {
  const [productMap, setProductMap] = useState(new Map());
  const { authToken, ezorder, role } = useContext(AuthContext);
  const navigate = useNavigate();
  const [sendQuoteDialogOpen, setSendQuoteDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { openSnackMessage } = useContext(SnackAlertContext);
  const [approveDialogOpen, setApproveDialogOpen] = useState(false);
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [requoteOrderDialogOpen, setRequoteOrderDialogOpen] = useState(false);
  const [actionsAnchor, setActionsAnchor] = useState(null);
  const [shopCompletionStatusDialogOpen, setShopCompletionStatusDialogOpen] =
    useState(false);
  const [rfpDialogOpen, setRfpDialogOpen] = useState(false);
  const [shopLogs, setShopLogs] = useState([]);

  const handleCloseActionMenu = () => {
    setActionsAnchor(null);
  };

  const getProductMap = () => {
    const prodMap = new Map();
    for (let i = 0; i < quote.items.length; i++) {
      let quoteItem = quote.items[i];
      prodMap.set(`${quoteItem.objectType}`, quoteItem);
    }
    setProductMap(prodMap);
  };

  const updateOrderSalesRep = async (salesRep) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      const response = await ezorder.put(
        `/admin/orders/${quote.id}/sales-rep`,
        {
          salesRepId: salesRep ? salesRep.id : null,
        },
        data,
      );

      if (response.status == 200 || response.status == 201) {
        openSnackMessage("success", "Updated");
        onQuoteUpdated();
      } else {
        openSnackMessage("error", response.response.data.error);
      }

      // setSalesRep(salesRep);
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const reopenOrder = async () => {
    try {
      setLoading(true);

      let formData = new FormData();
      formData.append("orderId", quote.id);
      formData.append("status", "QUOTE_REQUESTED");
      const response = await ezorder.patch(
        `/admin/orders/${quote.id}/status`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "content-type": "multipart/form-data",
          },
        },
      );

      if (response.status == 200 || response.status == 201) {
        onQuoteUpdated();
        openSnackMessage("success", "Quote Reopened!");
      } else {
        console.log(response);
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const completeOrder = async () => {
    try {
      setLoading(true);

      let formData = new FormData();
      formData.append("orderId", quote.id);
      formData.append("status", "CLOSED");

      const response = await ezorder.patch(
        `/admin/orders/${quote.id}/status`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "content-type": "multipart/form-data",
          },
        },
      );

      if (response.status == 200 || response.status == 201) {
        openSnackMessage("success", "Job Completed");
        onQuoteUpdated();
      } else {
        console.log(response);
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  const getShopLogs = async () => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };

      const response = await ezorder.get(`/shop/orders/${quote.id}/shop-logs`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status == 200 || response.status == 201) {
        setShopLogs(response.data.shopLogs);
      } else {
        openSnackMessage("error", response.response.data.error);
      }

      // setSalesRep(salesRep);
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (quote) {
      getProductMap();
      getShopLogs();
    }
  }, [quote]);

  if (!productMap || !quote) return null;
  return (
    <Box sx={{ padding: "16px" }}>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Box sx={{ flex: 1 }}>
          <Box
            sx={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <OrderTitle order={quote} includeStatus={true} />
          </Box>
          <PrintableQRCode
            jobId={quote.id}
            customerName={quote.company ? quote.company.name : ""}
            jobName={quote.project ? quote.project.name : ""}
            displaySize={100}
            // url={`${window.location.host}/orders/${quote.id}`}
            url={`${window.location.host}/job-pickups/${quote.id}`}
          />
        </Box>
        <Typography variant="h5">
          Out The Door Cost:{" "}
          {currencyFormatNoDecimals(
            Math.round(Number(quote.outTheDoorCost ?? 0)),
          )}
        </Typography>
      </Box>

      {/* Actions */}
      <Box sx={{}}>
        <Typography variant="h6">Shop</Typography>
        <Button
          variant="outlined"
          sx={{ marginRight: "8px" }}
          onClick={() => {
            setShopCompletionStatusDialogOpen(true);
          }}
        >
          Update Status
        </Button>
        <Button
          variant="outlined"
          sx={{ marginRight: "8px" }}
          onClick={() => {
            setRfpDialogOpen(true);
          }}
        >
          RFP
        </Button>
      </Box>
      <ShopCompletionStatusDialog
        allowCompleteAll={true}
        orderId={quote.id}
        open={shopCompletionStatusDialogOpen}
        onClose={() => {
          setShopCompletionStatusDialogOpen(false);
        }}
        onSuccess={() => {
          setShopCompletionStatusDialogOpen(false);
          onQuoteUpdated(); // reload quote
          getShopLogs(); // reload shop logs
        }}
      />
      <RFPDialog
        orderId={quote.id}
        open={rfpDialogOpen}
        onClose={() => {
          setRfpDialogOpen(false);
        }}
        onSuccess={() => {
          setRfpDialogOpen(false);
          onQuoteUpdated(); // reload quote
          getShopLogs(); // reload shop logs
        }}
      />

      {/* Documents Section */}
      <Box sx={{ marginTop: "16px" }}>
        <Typography variant="h6">Documents</Typography>
        <Box sx={{ padding: "8px", display: "flex", flexDirection: "row" }}>
          {quote.estimatePdf && (
            <Button
              onClick={() =>
                estimatePdfDownloadHandler(
                  quote.estimatePdf,
                  authToken,
                  null,
                  null,
                  `CUSTOMER-QUOTE-${quote.id}-${quote.company.name}-${quote.project.name}.pdf`,
                )
              }
              variant="outlined"
              color="success"
              sx={{ marginRight: "8px" }}
            >
              <Download sx={{ marginRight: "8px" }} />
              Quote
            </Button>
          )}
          {quote.signedEstimatePDF && (
            <Button
              onClick={() =>
                estimatePdfDownloadHandler(
                  quote.signedEstimatePDF,
                  authToken,
                  null,
                  null,
                  `SIGNED-CUSTOMER-QUOTE-${quote.id}-${quote.company.name}-${quote.project.name}.pdf`,
                )
              }
              variant="outlined"
              color="success"
              sx={{ marginRight: "8px" }}
            >
              <Download sx={{ marginRight: "8px" }} />
              Signed Quote
            </Button>
          )}
          {/* Work Order is for Shop. DO NOT INCLUDE ANY COST */}
          {quote.orderStatus && ( // has Status Approved and beyond (include cancelled?)
            // quote.orderStatus.name !== "SAVED" &&
            // quote.orderStatus.name !== "QUOTE_REQUESTED" &&
            // quote.orderStatus.name !== "ESTIMATE_APPROVAL_NEEDED" &&
            <WorkOrderButton
              orderId={quote.id}
              variant="outlined"
              color="success"
              sx={{ marginRight: "8px" }}
            />
          )}
          {/* Material & Labor Summary is For ADMIN ONLY - INCLUDES COST*/}
          {quote.orderStatus && ( // has Status Approved and beyond (include cancelled?)
            // quote.orderStatus.name !== "SAVED" &&
            // quote.orderStatus.name !== "QUOTE_REQUESTED" &&
            // quote.orderStatus.name !== "ESTIMATE_APPROVAL_NEEDED" &&
            <WorkOrderButton
              orderId={quote.id}
              isMaterialAndLaborSummary={true}
              variant="outlined"
              color="success"
              sx={{ marginRight: "8px" }}
            />
          )}
        </Box>
      </Box>

      <Box sx={{ paddingTop: "16px" }}>
        <Box sx={{ mb: "15px", mt: 0, display: "flex" }}>
          <Typography variant="h6" sx={{ marginRight: "8px" }}>
            Purchase Orders
          </Typography>
          <Button
            variant="outlined"
            onClick={() => {
              navigate(`/orders/${quote.id}/purchase-orders/new`);
            }}
          >
            <Add />
            Create
          </Button>
        </Box>
        <PurchaseOrders selectedOrderId={quote.id} isForOrder={true} />
      </Box>

      {quote.signedEstimatePDF && (
        <Box sx={{}}>
          <Box sx={{ display: "flex" }}>
            <Typography variant="h6" sx={{ marginRight: "8px" }}>
              Job Schedule
            </Typography>
          </Box>
          {/* <JobDetails jobId={quote.id} /> */}
          <JobSchedule orderId={quote.id} />
        </Box>
      )}

      <Box sx={{ display: "flex", flexDirection: "row" }}>
        {quote.quoteType !== "Free Text" && (
          <>
            <Box sx={{}}>
              <Typography variant="h6">Components Included</Typography>
              <Box sx={{ padding: "8px" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("FlatSheet")}
                  />
                  <Typography>Flat Sheet</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("Coil")}
                  />
                  <Typography>Coil</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("Panel")}
                  />
                  <Typography>Panel</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("TrimAndFlashing")}
                  />
                  <Typography>Trim & Flashing</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("BenchWork")}
                  />
                  <Typography>BenchWork</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("CopingCap")}
                  />
                  <Typography>Coping Cap</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("CopingCapCleat")}
                  />
                  <Typography>Coping Cap Cleat</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("SplicePlate")}
                  />
                  <Typography>Splice Plate</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    magin: 0,
                    padding: 0,
                  }}
                >
                  <Checkbox
                    disabled
                    style={{
                      magin: 0,
                      padding: 0,
                    }}
                    checked={productMap.has("Accessory")}
                  />
                  <Typography>Extra Accessories</Typography>
                </Box>
              </Box>
            </Box>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ marginLeft: "16px", marginRight: "16px" }}
            />
          </>
        )}

        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Typography variant="h6">Details</Typography>
          <SelectSalesRep
            disabled={!quote.company}
            companyId={quote.company ? quote.company.id : null}
            value={quote.salesRep}
            onUpdate={(user) => {
              if (user) updateOrderSalesRep(user);
            }}
            label="Sales Rep"
          />

          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Box sx={{ marginRight: "16px" }}>
              <TextField
                sx={{ width: "200px" }}
                InputProps={{
                  readOnly: true, // This makes the input read-only
                }}
                size="small"
                label="Cut List Type"
                value={quote.quoteType}
              />
            </Box>
            {quote.quoteType !== "Free Text" && (
              <FormControlLabel
                control={<Switch checked={quote.isItemizedEstimate} />}
                label="Show Price Per Piece to Customer"
                InputProps={{
                  readOnly: true, // This makes the input read-only
                }}
              />
            )}
          </Box>

          {quote.isCustomMaterial ? (
            <>
              <TextField
                InputProps={{
                  readOnly: true, // This makes the input read-only
                }}
                size="small"
                label="Custom Material"
                value={`${quote.customColor}${
                  quote.customManufacturer
                    ? ` - ${quote.customManufacturer}`
                    : ""
                }`}
              />
            </>
          ) : (
            <>
              <TextField
                InputProps={{
                  readOnly: true, // This makes the input read-only
                }}
                size="small"
                label="Color"
                value={
                  quote.color || quote.manufacturer
                    ? `${quote.color} - ${quote.manufacturer}`
                    : ""
                }
              />
              <TextField
                InputProps={{
                  readOnly: true, // This makes the input read-only
                }}
                size="small"
                label="Gauge"
                value={quote.gauge}
              />
              <TextField
                InputProps={{
                  readOnly: true, // This makes the input read-only
                }}
                size="small"
                label="Width (in.)"
                value={quote.flatSheetSize}
              />
            </>
          )}
          {quote.quoteType !== "Free Text" && (
            <TextField
              InputProps={{
                readOnly: true, // This makes the input read-only
              }}
              size="small"
              label="Notes"
              value={quote.quoteNotes}
            />
          )}
        </Box>
      </Box>

      {quote.quoteType === "Free Text" ? (
        <Box sx={{}}>
          <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
          <Typography variant="h6" sx={{ marginBottom: "8px" }}>
            Quote Summary / Notes
          </Typography>
          <TextField
            disabled
            multiline
            rows={20}
            variant="outlined"
            id="quoteNotes"
            name="quoteNotes"
            fullWidth
            value={quote.quoteNotes}
          />
        </Box>
      ) : (
        <>
          <Typography variant="h6" sx={{ marginTop: "32px" }}>
            Skid Charge -{" "}
            {currencyFormatNoDecimals(Number(quote.skidCharge ?? 0))}
          </Typography>

          {productMap.get("FlatSheet") && (
            <FlatSheet
              flatSheet={productMap.get("FlatSheet")}
              sx={{ marginTop: "32px" }}
            />
          )}

          {productMap.get("Coil") && (
            <Coil coil={productMap.get("Coil")} sx={{ marginTop: "32px" }} />
          )}

          {productMap.get("Panel") && (
            <Panel
              cutsSortOrder="id"
              panel={productMap.get("Panel")}
              sx={{ marginTop: "32px" }}
            />
          )}

          {productMap.get("TrimAndFlashing") && (
            <TrimAndFlashing
              trim={productMap.get("TrimAndFlashing")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("BenchWork") && (
            <BenchWork
              benchWork={productMap.get("BenchWork")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("CopingCap") && (
            <CopingCap
              copingCap={productMap.get("CopingCap")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("CopingCapCleat") && (
            <CopingCapCleat
              cleat={productMap.get("CopingCapCleat")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("SplicePlate") && (
            <SplicePlate
              splicePlate={productMap.get("SplicePlate")}
              style={{ marginTop: "32px" }}
            />
          )}
          {productMap.get("Accessory") && (
            <Accessory
              accessory={productMap.get("Accessory")}
              style={{ marginTop: "32px", marginBottom: "32px" }}
            />
          )}
        </>
      )}

      {quote.orderStatus && // has Status Approved and beyond (include cancelled?)
        quote.estimatePdf && (
          <Box sx={{ marginTop: "32px" }}>
            <MaterialSummary order={quote} />
          </Box>
        )}

      {quote.orderStatus && // has Status Approved and beyond (include cancelled?)
        quote.estimatePdf && (
          <Box sx={{ marginTop: "32px" }}>
            <LaborSummary order={quote} />
          </Box>
        )}

      <Box sx={{ marginTop: "32px" }}>
        <Comments orderId={quote.id} />
      </Box>

      <Box sx={{}}>
        <Typography variant="h6">Logs</Typography>
        <TableContainer component={Box}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shopLogs &&
                shopLogs.map((shopLog, index) => (
                  <TableRow key={shopLog.id}>
                    <TableCell>
                      {dayjs(shopLog.createdAt)
                        .tz("America/Phoenix")
                        .format("MM/DD/YY")}
                    </TableCell>
                    <TableCell>{shopLog.logType}</TableCell>
                    <TableCell>{shopLog.user.fullName}</TableCell>
                    <TableCell>{shopLog.text}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <div
        style={{
          position: "fixed",
          bottom: "20px",
          right: "50px",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <>
          <Fab
            onClick={(event) => {
              // setSendQuoteDialogOpen(true);
              setActionsAnchor(event.currentTarget);
            }}
            variant="extended"
            color="success"
          >
            Actions <KeyboardArrowUp />
          </Fab>
          <Menu
            id="demo-customized-menu"
            slotProps={{
              list: {
                "aria-labelledby": "demo-customized-button",
              },
            }}
            anchorEl={actionsAnchor}
            open={actionsAnchor}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            onClose={handleCloseActionMenu}
          >
            {/* QUOTE ACTIONS - QUOTE_REQUESTED or ESTIMATE_APPROVAL_NEEDED */}
            {quote.orderStatus &&
              (quote.orderStatus.name == "QUOTE_REQUESTED" ||
                quote.orderStatus.name == "ESTIMATE_APPROVAL_NEEDED") && (
                <>
                  <MenuItem
                    disableRipple
                    disabled={
                      !quote.orderStatus ||
                      quote.orderStatus.name !== "QUOTE_REQUESTED"
                    }
                    onClick={() => {
                      navigate(`/quotes/${quote.id}/edit`);
                      handleCloseActionMenu();
                    }}
                  >
                    <Edit sx={{ marginRight: "8px" }} />
                    Edit
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    disabled={
                      !(
                        quote.orderStatus &&
                        quote.estimatePdf &&
                        (quote.orderStatus.name === "QUOTE_REQUESTED" ||
                          quote.orderStatus.name === "ESTIMATE_APPROVAL_NEEDED")
                      )
                    }
                    onClick={() => {
                      setSendQuoteDialogOpen(true);
                      handleCloseActionMenu();
                    }}
                    disableRipple
                  >
                    <Send sx={{ marginRight: "8px" }} />
                    {quote.estimateLastSentForApproval
                      ? `Re-Send For Approval`
                      : `Send For Approval`}
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    disableRipple
                    disabled={
                      !quote.orderStatus ||
                      quote.orderStatus.name !== "ESTIMATE_APPROVAL_NEEDED"
                    }
                    onClick={() => {
                      reopenOrder();
                      handleCloseActionMenu();
                    }}
                  >
                    <Undo sx={{ marginRight: "8px" }} />
                    Re-Open for Editing
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    disabled={
                      !(
                        quote.orderStatus &&
                        quote.estimatePdf &&
                        (quote.orderStatus.name === "QUOTE_REQUESTED" ||
                          quote.orderStatus.name === "ESTIMATE_APPROVAL_NEEDED")
                      ) || quote.quoteType == "Preliminary Cut-List"
                    }
                    onClick={() => {
                      setApproveDialogOpen(true);
                      handleCloseActionMenu();
                    }}
                    disableRipple
                  >
                    <Check sx={{ marginRight: "8px" }} />
                    Approve Manually
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    disabled={
                      quote.orderStatus.name === "CANCELLED" ||
                      quote.orderStatus.name === "CLOSED"
                    }
                    onClick={() => {
                      setCancelDialogOpen(true);
                      handleCloseActionMenu();
                    }}
                    disableRipple
                  >
                    <Close sx={{ marginRight: "8px" }} />
                    Cancel Quote
                  </MenuItem>
                </>
              )}

            {/* JOB ACTIONS */}
            {quote.orderStatus &&
              quote.orderStatus.name !== "SAVED" &&
              quote.orderStatus.name !== "QUOTE_REQUESTED" &&
              quote.orderStatus.name !== "ESTIMATE_APPROVAL_NEEDED" && (
                <>
                  <MenuItem
                    disabled={
                      quote.orderStatus.name === "CANCELLED" ||
                      quote.orderStatus.name === "CLOSED"
                    }
                    onClick={() => {
                      // setCloseDialogOpen(true);
                      completeOrder();
                      handleCloseActionMenu();
                    }}
                    disableRipple
                  >
                    <Check sx={{ marginRight: "8px" }} />
                    Job Complete
                  </MenuItem>
                  <Divider sx={{ my: 0.5 }} />
                  {/* TODO: SCHEDULE? */}
                  {/* CREATE INVOICE / GO TO INVOICE */}
                  {/* <Divider sx={{ my: 0.5 }} /> */}
                  <MenuItem
                    onClick={() => {
                      handleCloseActionMenu();
                      navigate(`/invoices/${quote.id}`);
                    }}
                    disableRipple
                  >
                    <AttachMoney sx={{ marginRight: "8px" }} />
                    Invoice
                  </MenuItem>
                  {/* TODO: MARK AS PAID?*/}
                  {/*  PICKUP HISTORY*/}
                  {/* <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    onClick={() => {
                      handleCloseActionMenu();
                      navigate(`/job-pickups/${quote.id}`);
                    }}
                    disableRipple
                  >
                    <LocalShipping sx={{ marginRight: "8px" }} />
                    Pickup History
                  </MenuItem> */}
                  {/*  REOPEN ORDER */}
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    disableRipple
                    disabled={
                      !quote.orderStatus &&
                      quote.orderStatus.name !== "ESTIMATE_APPROVED"
                    }
                    onClick={() => {
                      handleCloseActionMenu();
                      setRequoteOrderDialogOpen(true);
                    }}
                  >
                    <Undo sx={{ marginRight: "8px" }} />
                    Re-Quote Order
                  </MenuItem>
                  {/*  CANCEL ORDER */}
                  <Divider sx={{ my: 0.5 }} />
                  <MenuItem
                    disabled={
                      quote.orderStatus.name === "CANCELLED" ||
                      quote.orderStatus.name === "CLOSED"
                    }
                    onClick={() => {
                      setCancelDialogOpen(true);
                      handleCloseActionMenu();
                    }}
                    disableRipple
                  >
                    <Close sx={{ marginRight: "8px" }} />
                    Cancel Order
                  </MenuItem>
                </>
              )}
          </Menu>
        </>
      </div>
      <SendQuoteDialog
        quote={quote}
        open={sendQuoteDialogOpen}
        handleClose={() => {
          setSendQuoteDialogOpen(false);
        }}
        onQuoteSent={onQuoteUpdated}
      />
      <AdminApproveDialog
        quoteId={quote.id}
        open={approveDialogOpen}
        onClose={() => {
          setApproveDialogOpen(false);
        }}
        companyId={quote.company.id}
        estimateApprovalDate={quote.estimateApprovalDate}
        signedEstimatePDF={quote.signedEstimatePDF}
        onSuccess={onQuoteUpdated}
        downloadName={`SIGNED-CUSTOMER-QUOTE-${quote.id}-${quote.company.name}-${quote.project.name}.pdf`}
      />
      <AdminCloseOrderDialog
        quoteId={quote.id}
        open={closeDialogOpen}
        onClose={() => {
          setCloseDialogOpen(false);
        }}
        onSuccess={onQuoteUpdated}
      />
      <AdminCancelOrderDialog
        quoteId={quote.id}
        open={cancelDialogOpen}
        onClose={() => {
          setCancelDialogOpen(false);
        }}
        onSuccess={onQuoteUpdated}
      />
      <AdminRequoteOrderDialog
        quoteId={quote.id}
        open={requoteOrderDialogOpen}
        onClose={() => {
          setRequoteOrderDialogOpen(false);
        }}
        onSuccess={onQuoteUpdated}
      />
    </Box>
  );
};

export default QuotePreview;
